import React from "react";

import { Alert, Box, Button, Typography } from "@mui/material";

import ModernModal from "../ModernModal";

interface ConfirmProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  description: string;
}

function Confirm({
  open,
  onClose,
  onConfirm,
  onCancel,
  title,
  description,
}: ConfirmProps) {
  return (
    <ModernModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="sm"
      actions={
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button variant="outlined" onClick={onCancel} sx={{ minWidth: 100 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{ minWidth: 100 }}
          >
            Confirm
          </Button>
        </Box>
      }
    >
      <Box sx={{ textAlign: "center", py: 2 }}>
        <Alert severity="warning" sx={{ mb: 3, textAlign: "left" }}>
          <Typography variant="body2">{description}</Typography>
        </Alert>
      </Box>
    </ModernModal>
  );
}

export { Confirm };
